<template>
  <vs-tr>
    <vs-td :colspan="colsCount" class="bg-white pt-10">
      <p class="flex md:justify-center justify-start md:w-full w-1/4">
        There are no data match your search
      </p>
    </vs-td>
  </vs-tr>
</template>

<script>
export default {
  props: ['colsCount']
}

</script>

<style scoped>
  p {
    height: 543px;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.107143px;
    color: rgba(0, 0, 0, 0.56);
  }
</style>